"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Chip;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _closeIcon = _interopRequireDefault(require("./closeIcon"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _container = _interopRequireDefault(require("./styled/container"));

var _truncatedText = _interopRequireDefault(require("../Structural/truncatedText"));

var _buttonIcon = _interopRequireDefault(require("./styled/buttonIcon"));

/**
 * A Chip displays a label that can be removed from view.
 */
function Chip(props) {
  var label = props.label,
      onDelete = props.onDelete,
      variant = props.variant,
      title = props.title,
      className = props.className,
      style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    className: className,
    style: style,
    variant: variant,
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_truncatedText["default"], null, label), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: onDelete
  }, /*#__PURE__*/_react["default"].createElement(_buttonIcon["default"], {
    variant: variant,
    icon: /*#__PURE__*/_react["default"].createElement(_closeIcon["default"], null),
    size: "small",
    title: "Close",
    onClick: onDelete,
    assistiveText: "Remove"
  })));
}

Chip.propTypes = {
  /** The content to be displayed inside the Chip. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Displays tooltip text when the mouse moves over the element. */
  title: _propTypes["default"].string,

  /** The variant changes the appearance of the Chip. Accepted variants include base,
   * neutral, outline-brand, brand, success, warning and error. This value defaults to base. */
  variant: _propTypes["default"].oneOf(['base', 'neutral', 'outline-brand', 'brand', 'success', 'warning', 'error']),

  /** The action triggered when the close button is clicked. */
  onDelete: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
Chip.defaultProps = {
  label: null,
  title: undefined,
  variant: 'base',
  onDelete: undefined,
  className: undefined,
  style: undefined
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Chip/index.js
// module id = g82n
// module chunks = 0